<template>
  <ion-refresher slot="fixed" @ionRefresh="updateNews($event)">
    <ion-refresher-content
        pulling-text="Pull to refresh...">
    </ion-refresher-content>
  </ion-refresher>
  <ion-item v-if="fetchActive" :style="{'text-align':'center'}">
    <ion-spinner></ion-spinner>
  </ion-item>
  <div v-if="posts && posts.length > 0">

    <div @click="collapse(post.id)" v-for="post in posts " :key="post.id" class="list card shadow news-card"
         :style="collapseStyle(post.id)"
    >
      <div v-if="post.unread" class="new-label"></div>
      <div>
        <ion-card-header style="position:relative;">

          <ion-card-subtitle class="news-time">{{
              moment(post.publish_at).format('dddd, MMMM D HH:mm')
            }}
            <div v-if="post.newstags && post.newstags.length > 0" style="display: inline-block">
              <template v-for="tag in post.newstags">
                <div class="news-tag" :key="tag.id" v-if="tag && tag.id"
                     :style="{'background': tag.bgcolor, 'color':tag.color}"><strong>{{ tag.title }}</strong>
                </div>
              </template>
            </div>
          </ion-card-subtitle>

          <ion-card-title style="font-size:20px !important;" class="news-title">{{ post.message.title }}
          </ion-card-title>
        </ion-card-header>
        <ion-card-content v-html="post.content" style="font-size:1rem !important; line-height: 1.2rem" class="news-content mb-1">
        </ion-card-content>
        <div @click="openLink(post.message.redirect)"
             v-if="post.message.redirect && post.message.redirect != '/app/posts'"
             class="position-absolute bottom-0 end-0 py-1 pe-1">
          <div class="btn btn-sm news-read-more">READ MORE</div>
        </div>
      </div>
    </div>
  </div>
  <div class="item item-text-wrap" style="padding: 20px!important; text-align: center; color:#fff !important;"
       v-if="!posts || posts.length <= 0">{{ wordings[currentLanguage].NO_NEWS }}
  </div>
</template>
<script>
import {
  IonContent,
  IonItem,
  IonRefresher,
  IonRefresherContent,
  IonCard,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCardContent,
  IonSpinner
} from "@ionic/vue";
import {defineComponent} from "vue";
import {mapActions, mapState, mapMutations} from "vuex";
import moment from 'moment';
import {addIcons} from "ionicons";
import {chevronDownOutline, chevronUpOutline} from "ionicons/icons";

addIcons({
  "chevron-down-outline": chevronDownOutline,
  "chevron-up-outline": chevronUpOutline,
});

export default defineComponent({
  name: "News",
  data() {
    return {
      collapsed: null
    };
  },
  components: {
    IonContent,
    IonItem,
    IonRefresher,
    IonRefresherContent,
    IonCard,
    IonCardHeader,
    IonCardSubtitle,
    IonCardTitle,
    IonCardContent,
    IonSpinner,
  },
  computed: {
    ...mapState('news', ['posts', 'fetchActive']),
    ...mapState('wordings', ['wordings', 'currentLanguage']),
    ...mapState('currentConference', ['currentConference', 'fullName', 'shortName', 'apiVersion', 'icon']),


  },
  methods: {
    ...mapActions("news", ["fetchNews"]),
    ...mapActions("personalDB", ['getItem', 'setTime', 'getUnreadNews']),
    ...mapMutations("personalDB", ['setUnreadNews']),
    async updateNews(event) {
      await this.fetchNews(this.currentConference);
      event.target.complete();
    },
    ...mapMutations('news', ['resetNewsNumber']),

    collapse(post) {
      if (post == this.collapsed) {
        this.collapsed = null;
      } else {
        this.collapsed = post;

      }
    },

    collapseStyle(post) {
      if (post == this.collapsed) {
        return {
          'max-height': 'none',
          'min-height': '140px !important',
        };
      } else {
        return {
          'max-height': '240px !important',
          'min-height': '140px !important',
          'text-overflow': 'ellipsis',
          'display': '-webkit-box',
          '-webkit-line-clamp': '9',
          'line-clamp': '9',
          '-webkit-box-orient': 'vertical',
          'overflow': 'auto'
        };
      }
    },
    openLink(link) {
      console.log('link', link)
      this.$router.push(link)
    },
    getIcon() {
      return this.icon ? 'url( ' + this.icon + ')' : 'url("@/assets/icon/icon.png")';
    }
  },

  async created() {
    this.moment = moment;
    await this.fetchNews(this.currentConference);
    await this.setTime({name: 'timeStamps_' + this.currentConference, item: new Date()});
    this.setUnreadNews(0);
  },
});
</script>
<style lang="scss" scoped>

.custom-background {
  --background: #002a32 !important;
}

a {
  text-decoration: none
}

.new-label {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: green;
  display: block;
  width: 10px;
  min-height: 10px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  z-index: 10;
  box-shadow: 0 0 0 rgba(0, 128, 0, 0.4);
  animation: pulse 2s infinite;
}

@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(0, 128, 0, 0.4);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
  }
}

@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(0, 128, 0, 0.4);
    box-shadow: 0 0 0 0 rgba(0, 128, 0, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
  }
}

@keyframes pulse2 {
  0% {
    -moz-box-shadow: 0 0 0 rgba(240, 0, 0, 1);
    box-shadow: 0 0 0 rgba(240, 0, 0, 1);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
  }
}

.news-icon {
  width: fit-content;
  text-align: center;
  width: 80px;
  height: 80px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}


</style>
<style lang="scss">
$esa-purple: #dfdaed;
$esa-violet: #642482;
$esa-blackgreen: #002a32;
$esa-blue: #47bccd;
.news-title {
  color: $esa-blackgreen;
  font-weight: 500;
}

.news-content {
  color: $esa-blackgreen;

  a {
    color: $esa-violet !important;
    text-decoration: none;
  }
}

.news-read-more {
  background-color: $esa-violet !important;
  color: #fff !important;
  border-radius: 10px;
}

.news-time {
  text-transform: none;
  font-size: 1rem;
  font-weight: normal;
}

.news-card {
  display: flex;
  flex-direction: row;
  margin: 10px 10px 20px 10px;
  border-radius: 10px !important;
}

.news-tag {
  height: 20px;
  width: fit-content;
  margin: 3px;
  padding: 1px 4px;
  border-radius: 10px;
  font-size: 0.7rem;
}
</style>
